import React, { useEffect, useState } from 'react';
import './style.sass';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { useForm } from "react-hook-form";
import { postEnviarOTP } from '../../../services/OTPservices';
import { decodeStorage } from 'functions/storageBase64';
import { BASE_PATH } from 'constants/general';
import { ModalError } from 'components/Error/ErrorModal';
import { Error500 } from 'components/Error/Error500';
import { useLogout } from 'hooks/useLogin';

export default function IngresarNumero(props) {
    const {
        setMostrarPaso2,
        setLoading,
        setNumero,
        setFlagActivarContador,
        activarContador,
        setKeySMS
    } = props;

    const { logOut } = useLogout();

    //variables tomadas del storage
    const session_token = decodeStorage('session_token');
    const profileData = decodeStorage('profileData');

    //variables para formulario
    const [datosFormulario, setDatosFormulario] = useState(false);
    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            numeroTelefono: datosFormulario.numeroTelefono,
        }
    });
    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);
    const [inputNumeroTelefono, setInputNumeroTelefono] = useState();

    //activa BOTON de envio de numero de telefono
    const [activarBoton, setActivarBoton] = useState(false);

    //variables para modal de error
    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [mostrarmensaje, setmostrasmensaje] = useState(false);


    //respuestas servicios
    const [postEnviarOTPvar, setPostEnviarOTPvar] = useState(false);

    // useEffect(() => {
    //     setLoading(false);
    // }, [])

    // guarda la informacion enviada en el formulario
    const sendFormulario = data => {
        setDatos({
            "id_client": profileData.idClaro,
            "mobile": data.numeroTelefono,
        })
        SetReturnForm(true);
    };
    // al recibir el numero de telefono realiza la peticion de codigo al servicio
    useEffect(() => {

        if (returnForm) {
            // envia informacion para solicitar sms
            postEnviarOTP(
                session_token,
                datos
            )
                .then(setPostEnviarOTPvar)
            setLoading(true);
            // SetReturnForm(false);
        }
    }, [returnForm])

    useEffect(() => {
        if (postEnviarOTPvar) {
            if (postEnviarOTPvar?.statusCode === 200 || postEnviarOTPvar?.statusCode === 200) {
                let nume = postEnviarOTPvar.data.data.mobile;
                let keyV = postEnviarOTPvar.data.data.key;
                // console.log("key... ", keyV)
                setKeySMS(keyV);
                setNumero(nume);
                setDatosFormulario(datos);
                SetReturnForm(false);
                setMostrarPaso2(true);
                setLoading(false);
                setFlagActivarContador(true);
                activarContador();
            }
            else if (Number(postEnviarOTPvar?.statusCode) === 400) {
                // console.log("responde 412, ", JSON.parse(postEnviarOTPvar.data)?.data.message)
                setLoading(false);
                setMensaje(JSON.parse(postEnviarOTPvar?.data)?.metadata?.message)
                setmostrasmensaje(true);
                SetReturnForm(false);
            }
            else if (Number(postEnviarOTPvar?.statusCode) === 412) {
                // console.log("responde 412, ", JSON.parse(postEnviarOTPvar.data)?.data.message)
                setLoading(false);
                if (JSON.parse(postEnviarOTPvar.data)?.data?.phoneExists === true) {
                    setMensaje(JSON.parse(postEnviarOTPvar?.data)?.metadata?.message)
                    setmostrasmensaje(true);
                    SetReturnForm(false);
                }
            }
            else if (postEnviarOTPvar?.statusCode != 401 && postEnviarOTPvar?.statusCode > 200 && postEnviarOTPvar?.statusCode < 500) {
                setShowModalErr(true);
                setErrorCode(postEnviarOTPvar?.statusCode);
                setSectionActive('verificar');
                setMessageResponse(JSON.parse(postEnviarOTPvar?.data)?.metadata?.message);
                setLoading(false);
            }
            else if (postEnviarOTPvar?.statusCode === 401) {
                logOut();
                window.location.href = `${BASE_PATH}login?redirect=${window.location.href}`
            }
            else {
                setErrorCode(500);
                setLoading(false);
            }
        }


    }, [postEnviarOTPvar])

    const resetErrors = (value) => {
        let inputId = document.querySelector(`#${value} ~ .error`)
        if (inputId) {
            let valu = value
            clearErrors(valu)
            reset({ valu }, {
                keepErrors: false,
                keepDirty: true,
                keepIsSubmitted: false,
                keepTouched: false,
                keepIsValid: false,
                keepSubmitCount: false,
            });
        }
    }

    //- Validaciones de campos para agregar numero de telefono
    const valNumeroTelefono = {
        required: 'Campo obligatorio',
        minLength: {
            value: 10,
            message: 'Faltan dígitos. Deben ser 10 dígitos'
        },
        maxLength: {
            value: 10,
            message: 'No debe contener más de 10 dígitos'
        }
    }

    // funciones para mostrar el modal
    const [showModal, SetShowModal] = useState(false);
    const showModalErrorCode = () => SetShowModal(true);
    const handleClose = () => SetShowModal(false);
    useEffect(() => {
        if (errorCode <= 499) {
            showModalErrorCode();
        }
    }, [errorCode])

    //activa el boton de enviar el numero de telefono
    useEffect(() => {

        if (inputNumeroTelefono && inputNumeroTelefono.length === 10) {
            setActivarBoton(true);
        }
        else {
            setActivarBoton(false);
        }
    }, [inputNumeroTelefono])

    // para ocultar mensaje de numero ya registrado...
    useEffect(() => {

        setmostrasmensaje(false);

    }, [inputNumeroTelefono])

    // valida respuesta del servicio y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'verificar') {
            window.location.href = `${BASE_PATH}`;
        }
    }

    return (
        <>
            {errorCode >= 500
                ? <Error500 />
                : <div className='verificacionNumeroBox'>
                    <div className='logoCopy marginBottom35'>
                        <img src='img/icono-creditocs.svg' alt='logo-cs' width={80}></img>
                        <p className='p16 marginTop30'>Ingresa tu número celular para enviar un código de confirmación</p>
                    </div>

                    <form className='marginTop50' onSubmit={handleSubmit(sendFormulario)}>
                        <div className='marginBottom35 prefijoNumero'>
                            <div className='unoP'>
                                <img src='img/bandera.png' width={30}></img>
                                <p>+52</p>
                            </div>

                            <div className='dosP'>
                                <InputTypeAndroid
                                    type="text"
                                    name="numeroTelefono"
                                    id="numeroTelefono"
                                    placeholder="Número celular"
                                    refs={register(valNumeroTelefono)}
                                    autocomplete='numeroTelefono'
                                    setNumero={setInputNumeroTelefono}
                                    numero={inputNumeroTelefono}
                                    errorMessage={errors.numeroTelefono && errors.numeroTelefono.message}
                                    pattern={'number'}
                                    minLength={10}
                                    maxLength={10}
                                    max="9999999999"
                                    className=""
                                />
                            </div>
                        </div>

                        {mostrarmensaje &&
                            <div className='boxMensaje'>
                                <p className='textMensaje'>{mensaje}</p>
                            </div>
                        }

                        <div className='botones marginTop8p'>
                            <button className='btn rojoDisabled' disabled={activarBoton ? false : true}>Continuar</button>
                        </div>
                    </form>
                </div>
            }

            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }
        </>
    )
}
